export default "__VITE_ASSET__DdHnKpaX__"